// extracted by mini-css-extract-plugin
export default {"popoverContent":"qOJrvx"};